import { Button } from "antd";
import "./button.css";

const getClassName = (type = "default") => {
	if (type === "primary") return "buttonOverwrite_primary";
	if (type === "secondary") return "buttonOverwrite_secondary";

	return "buttonOverwrite_default";
};
const GalkButton = ({
	children,
	type,
	width,
	height = "42px",
	additionalStyle,
	...rest
}) => {
	const addStyle = additionalStyle ? { ...additionalStyle } : {};
	const widthStyle = width ? { width: width } : {};
	const heightStyle = height ? { height } : {};

	return (
		<div className={getClassName(type)}>
			<Button {...rest} style={{ ...widthStyle, ...heightStyle, ...addStyle }}>
				{children}
			</Button>
		</div>
	);
};

export default GalkButton;
